/*istanbul ignore file */
export const migrations = {
  0: state => {
    return {
      ...state
    };
  }
} as any;
